export default {install (Vue) 
    {
    const valoresHeader = {
        obtenerNombreArchivo(disposition) {
            if (disposition && disposition.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) { 
                  return  matches[1].replace(/['"]/g, '');
                }
            }
        },
        
  }
  Vue.prototype.$valoresHeader = valoresHeader;
}}